import React from 'react'
import { mount } from 'enzyme'

import Probability from '../Probability'

describe('<Probability />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      title: 'test title',
      message: 'test message',
      value: 'test value'
    }
    wrapper = mount(<Probability {...props} />)
  })
  describe('when its value prop is defined', () => {
    it('should render the value prop', () => {
      expect(wrapper.find('Probability__Bold').text()).toBe(props.value)
    })
  })
  describe('when its value prop is not defined', () => {
    beforeEach(() => {
      wrapper.setProps({ value: null })
    })
    it('should not render the value prop', () => {
      expect(wrapper.find('Probability__Percentage')).toHaveLength(0)
    })
  })
  it('should render its provided title prop', () => {
    expect(wrapper.find('Probability__ProbabilityTitle').text()).toBe(props.title)
  })
  it('should render its provided message prop', () => {
    expect(wrapper.find('Probability__Smaller').text()).toBe(props.message)
  })
})
